import moment from "moment-hijri";

const hijriMonths = [
  "Muharram",
  "Safar",
  "Rabi al-Awwal",
  "Rabi al-Thani",
  "Jumada al-Awwal",
  "Jumada al-Thani",
  "Rajab",
  "Shaban",
  "Ramadan",
  "Shawwal",
  "Dhul Qadah",
  "Dhul Hijjah",
];

export function formatHijri(inputDate, dateType = "gregorian") {
  if (!inputDate) return "";

  let hijriDate;

  if (dateType === "hijri") {
    if (typeof inputDate === "string" && inputDate.includes("i")) {
      hijriDate = moment(inputDate, ["iYYYY-iMM-iDD", "iDD-iMM-iYYYY"]);
    } else {
      hijriDate = moment(inputDate);
    }
  } else {
    hijriDate = moment(inputDate, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY", "MM-DD-YYYY", "MM-DD-YY", "DD-MM-YY"]);
  }

  const day = hijriDate.iDate();
  const month = hijriMonths[hijriDate.iMonth()];
  const year = hijriDate.iYear();

  return `${day} ${month} ${year} Hijri`;
}
